import React, { useState, createContext } from 'react';

export const ShiftContext = createContext();

const ShiftProvider = ({ children }) => {
  const [shift, setShift] = useState(localStorage.getItem('shiftStored') || 'day');

  return (
    <ShiftContext.Provider
      value={{
        shift,
        setShift: () => setShift(shift === 'night' ? 'day' : 'night'),
      }}
    >
      {children}
    </ShiftContext.Provider>
  );
};

export default ShiftProvider;
